module.exports = __webpack_public_path__ + "images/on-the-strip-ded7d60abb1b24609586de59558f133a.png";